module.exports = __webpack_public_path__ + "media/stylesheets/botyglot/default-theme/20-static/icons/block-aac76488815691bc23b200df7b0b6588.svg";